import style from "./InputField.module.scss";
import React from "react";

const InputField = ({error, placeHolder, value, onChange}: {
    error?: string,
    placeHolder?: string,
    value?: string,
    onChange?: (value: string) => void
}) => {
    if (placeHolder === "E-mail" || placeHolder === '+7') {
        return (
            <div className={style.inputContainer}>
                <input className={style.inputField}
                       placeholder={placeHolder}
                       value={value}
                       onChange={(e) => onChange && onChange(e.target.value)}
                />
                <div className={style.error}>{error}</div>
            </div>
        )
    } else {
        return (
            <input className={style.inputField} placeholder={placeHolder} value={value}
                   onChange={(e) => onChange && onChange(e.target.value)}/>
        )
    }
}

export default InputField;